import React from "react"
import FeatherIcon from "feather-icons-react"
import iconLink from "./iconlink.module.scss"

export default props => {
  return (
    <a
      className={props.dark ? iconLink.linkdark : iconLink.linklight}
      href={props.href}
    >
      <FeatherIcon icon={props.icon} />
      {props.text}
    </a>
  )
}
